module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Temperature-empty-31b689a881414c59a60e521048cc6488.svg";